import React from 'react'
import { useMutation } from 'react-query'
import { useSelector, useDispatch } from 'react-redux'
import { deleteMultipleContacts } from '../../../../../api/DELETE/delContactAddresses'
import {
  selectSelectedContacts,
  removeSelectedContacts,
  removeDeletedContacts,
  selectIsDeleteMode,
  toggleDeleteMode,
} from '../../../../../slices/contactAddressSlice'
import { selectContactFilterType } from '../../../../../slices/contactAddressSlice'
import { selectRole } from '../../../../../slices/authSlice'

export const BulkDeleteButton = () => {
  const dispatch = useDispatch()
  const loggedinUserRole = useSelector(selectRole)
  const contactFilterType = useSelector(selectContactFilterType)
  const deletedContacts = useSelector(selectSelectedContacts)
  const isDeleteMode = useSelector(selectIsDeleteMode)

  const shouldShowButton =
    (loggedinUserRole === 4 && (contactFilterType === 'personal' || contactFilterType === 'all' || contactFilterType === '')) ||
    (loggedinUserRole !== 4);

  const bulkDeleteMutation = useMutation(deleteMultipleContacts, {
    onSuccess: (_, variables) => {
      dispatch(removeDeletedContacts(variables)) // Redux state update
      dispatch(removeSelectedContacts())         // 選択リスト初期化
      dispatch(toggleDeleteMode())               // 削除モード終了
    },
    onError: (err: any) => {
      if (err.response?.status === 409) {
        alert(err.response.data.detail)
      } else if (err.response?.status === 401) {
        alert("セッションが切れています。再度ログインしてください。")
      } else if (err.response?.status === 404) {
        alert("連絡先の一括削除に失敗しました")
      } else {
        alert("予期せぬエラーが発生しました")
      }
      console.error("削除失敗:", err)
    },
  })

  const handleDeleteSelected = () => {
    if (deletedContacts.length === 0) return

    const isConfirmed = window.confirm("本当に選択した項目を削除しますか？")
    if (!isConfirmed) return

    bulkDeleteMutation.mutate(deletedContacts)
  }

  const handleCancelDeleteMode = () => {
    dispatch(toggleDeleteMode())
  }

  return shouldShowButton ? (
    <div>
      {!isDeleteMode && (
        <button
          className="bulk-delete-button"
          onClick={() => dispatch(toggleDeleteMode())}
        >
          一括削除
        </button>
      )}
      {isDeleteMode && (
        <div className="delete-mode-buttons">
          <button
            className="delete-confirm-button"
            onClick={handleDeleteSelected}
            disabled={deletedContacts.length === 0}
          >
            選択した項目を削除
          </button>
          <button
            className="cancel-button"
            onClick={handleCancelDeleteMode}
          >
            解除
          </button>
        </div>
      )}
    </div>
  ) : null
}
